import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "tp-cell__head" }
const _hoisted_3 = { class: "tp-cell__name" }
const _hoisted_4 = {
  key: 0,
  class: "tp-cell__required"
}
const _hoisted_5 = {
  key: 1,
  class: "tp-cell__badge tp-cell__badge--hidden"
}
const _hoisted_6 = {
  key: 2,
  class: "tp-cell__badge tp-cell__badge--reference"
}
const _hoisted_7 = {
  key: 3,
  class: "tp-cell__badge tp-cell__badge--carry"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "tp-cell__label-body"
}
const _hoisted_10 = {
  key: 1,
  class: "tp-cell__body"
}
const _hoisted_11 = {
  key: 0,
  class: "tp-cell__reference-value"
}
const _hoisted_12 = {
  key: 1,
  class: "tp-cell__reference-warning"
}
const _hoisted_13 = {
  key: 2,
  class: "tp-cell__reference-source"
}
const _hoisted_14 = {
  key: 2,
  class: "tp-cell__body"
}
const _hoisted_15 = ["value", "rows"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value", "disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value", "disabled"]
const _hoisted_20 = ["value", "disabled", "placeholder"]
const _hoisted_21 = {
  key: 4,
  class: "tp-cell__error"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tp-cell", {
      'tp-cell--label': _ctx.cell.type === 'label',
      'tp-cell--reference': _ctx.cell.type === 'reference',
      'tp-cell--carry': _ctx.transfer !== null,
      'tp-cell--selected': _ctx.selected,
      'tp-cell--hidden': !_ctx.cell.visible,
      'tp-cell--readonly': _ctx.isReadonly,
      'tp-cell--invalid': _ctx.valueError !== '',
    }]),
    tabindex: _ctx.rootTabIndex,
    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onCellClick && _ctx.onCellClick(...args))),
    onFocus: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onCellFocus && _ctx.onCellFocus(...args))),
    onKeydown: _cache[30] || (_cache[30] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onCellEnter && _ctx.onCellEnter(...args)), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cell.name), 1),
      (_ctx.cell.required && _ctx.isInput)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "必須"))
        : _createCommentVNode("", true),
      (!_ctx.cell.visible)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Excel非出力"))
        : _createCommentVNode("", true),
      (_ctx.cell.type === 'reference')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 参照 "))
        : _createCommentVNode("", true),
      (_ctx.transfer)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "転記"))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      (_ctx.commentCount > 0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 4,
            class: "tp-cell__badge tp-cell__badge--comment",
            title: `未解決のコメントが${_ctx.commentCount}件あります`
          }, [
            _createVNode(_component_v_icon, { size: "12" }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("mdi-comment-text-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.commentCount), 1)
          ], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    (_ctx.cell.type === 'label')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : (_ctx.cell.type === 'reference')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.reference && _ctx.reference.resolution === 'resolved')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.reference.value || "（参照元が未入力です）"), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.referenceWarning), 1)),
            (_ctx.reference && _ctx.reference.sourcePlanLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", null, "参照元: " + _toDisplayString(_ctx.reference.sourcePlanLabel), 1),
                  (_ctx.reference.sourcePlanId)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: "ml-2",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('jump-source', _ctx.reference.sourcePlanId)), ["stop","prevent"]))
                      }, " 開く "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.isTextType)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.editing)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["tp-cell__text", {
            'tp-cell__text--empty': !_ctx.draft,
            'tp-cell__text--required': !_ctx.draft && _ctx.cell.required && !_ctx.isReadonly,
          }])
                      }, _toDisplayString(_ctx.draft || _ctx.displayPlaceholder), 3))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.cell.type === 'longText')
                          ? (_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              ref: "input",
                              class: "tp-cell__input tp-cell__input--long",
                              value: _ctx.draft,
                              rows: _ctx.editorRows,
                              placeholder: "入力してください",
                              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                              onCompositionstart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.composing = true)),
                              onCompositionend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCompositionEnd && _ctx.onCompositionEnd(...args))),
                              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.focused = true)),
                              onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                              onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEscKey && _ctx.onEscKey(...args)), ["stop"]), ["esc"])),
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                            }, null, 40, _hoisted_15))
                          : (_openBlock(), _createElementBlock("input", {
                              key: 1,
                              ref: "input",
                              class: "tp-cell__input",
                              type: "text",
                              value: _ctx.draft,
                              placeholder: "入力してください",
                              onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                              onCompositionstart: _cache[9] || (_cache[9] = ($event: any) => (_ctx.composing = true)),
                              onCompositionend: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onCompositionEnd && _ctx.onCompositionEnd(...args))),
                              onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.focused = true)),
                              onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                              onKeydown: [
                                _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEscKey && _ctx.onEscKey(...args)), ["stop"]), ["esc"])),
                                _cache[14] || (_cache[14] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)), ["stop"]), ["enter"]))
                              ],
                              onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                            }, null, 40, _hoisted_16)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["tp-cell__counter", { 'tp-cell__counter--over': _ctx.valueError !== '' }])
                        }, [
                          (_ctx.valueMaxLength !== null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.draft.length.toLocaleString()) + " / " + _toDisplayString(_ctx.valueMaxLength.toLocaleString()) + "文字 ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.draft.length) + "文字", 1)
                              ], 64)),
                          _cache[32] || (_cache[32] = _createTextVNode(" ・Escで閉じる ", -1))
                        ], 2)
                      ], 64))
                ], 64))
              : (_ctx.cell.type === 'select')
                ? (_openBlock(), _createElementBlock("select", {
                    key: 1,
                    class: "tp-cell__input",
                    value: _ctx.draft,
                    disabled: _ctx.isReadonly,
                    onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onSelectChange && _ctx.onSelectChange(...args))),
                    onFocus: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onControlFocus && _ctx.onControlFocus(...args))),
                    onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onControlFocus && _ctx.onControlFocus(...args)), ["stop"]))
                  }, [
                    _cache[33] || (_cache[33] = _createElementVNode("option", { value: "" }, "未選択", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cell.options || [], (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option,
                        value: option
                      }, _toDisplayString(option), 9, _hoisted_18))
                    }), 128))
                  ], 40, _hoisted_17))
                : (_ctx.cell.type === 'date')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 2,
                      class: "tp-cell__input",
                      type: "date",
                      value: _ctx.draft,
                      disabled: _ctx.isReadonly,
                      onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onSelectChange && _ctx.onSelectChange(...args))),
                      onFocus: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onControlFocus && _ctx.onControlFocus(...args))),
                      onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onControlFocus && _ctx.onControlFocus(...args)), ["stop"]))
                    }, null, 40, _hoisted_19))
                  : (_ctx.cell.type === 'number')
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 3,
                        class: "tp-cell__input",
                        type: "number",
                        value: _ctx.draft,
                        disabled: _ctx.isReadonly,
                        placeholder: _ctx.isReadonly ? '—' : '数値を入力',
                        onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                        onFocus: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocus && _ctx.onNumberFocus(...args))),
                        onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                        onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onControlFocus && _ctx.onControlFocus(...args)), ["stop"]))
                      }, null, 40, _hoisted_20))
                    : _createCommentVNode("", true),
            (_ctx.valueError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_v_icon, { size: "12" }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createTextVNode("mdi-alert-circle-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.valueError) + "（このままでは保存されません） ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.transfer)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  class: _normalizeClass(["tp-cell__transfer-note", { 'tp-cell__transfer-note--unresolved': _ctx.transferWarning !== '' }])
                }, [
                  _createVNode(_component_v_icon, { size: "12" }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode("mdi-arrow-down-bold-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  (_ctx.transferWarning)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.transferWarning), 1))
                    : (_ctx.transfer.sourcePlanLabel)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "転記元: " + _toDisplayString(_ctx.transfer.sourcePlanLabel), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "上位計画から引き込み")),
                  (_ctx.transfer.sourcePlanId)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: "#",
                        class: "ml-1",
                        tabindex: "-1",
                        onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.$emit('jump-source', _ctx.transfer.sourcePlanId)), ["stop","prevent"]))
                      }, " 開く "))
                    : _createCommentVNode("", true),
                  (_ctx.transfer.canPull && _ctx.editable)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        href: "#",
                        class: "ml-1",
                        tabindex: "-1",
                        onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.$emit('transfer-cell', _ctx.cell.itemKey)), ["stop","prevent"]))
                      }, " 引き込む "))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]))
  ], 42, _hoisted_1))
}